import errorHandler from "../../handlers/errorHandler";
import successHandler from "../../handlers/successHandler";
import { revenuePayoutService } from "../../services/revenuePayout.service";
import payoutType from "./revenuePayoutTypes";

/**
 * Get all revenue payout
 **/

export const getAllRevenuePayout = (page) => async (dispatch) => {
  try {
    dispatch({ type: payoutType["LOADING_REVENUE_PAYOUT"], payLoad: true });
    const response = await revenuePayoutService.getAllRevenuePayout(page);
    dispatch({ type: payoutType["LOADING_REVENUE_PAYOUT"], payLoad: false });
    dispatch({ type: payoutType["ALL_REFERRALS"], payLoad: response });
  } catch (error) {
    dispatch({ type: payoutType["LOADING_REVENUE_PAYOUT"], payLoad: false });
  }
};

/**
 * Get a revenue payout
 **/

export const showARevenuePayout = (id) => async (dispatch) => {
  try {
    dispatch({ type: payoutType["LOADING_REVENUE_PAYOUT"], payLoad: true });
    const response = await revenuePayoutService.showARevenuePayout(id);
    dispatch({ type: payoutType["LOADING_REVENUE_PAYOUT"], payLoad: false });
    dispatch({ type: payoutType["SHOW_REVENUE_PAYOUT"], payLoad: response });
  } catch (error) {
    dispatch({ type: payoutType["LOADING_REVENUE_PAYOUT"], payLoad: false });
  }
};

/**
 * Get all referrals
 **/

export const getAllRevenuePayoutsNoPagination =
  (payload, page) => async (dispatch) => {
    try {
      dispatch({ type: payoutType["DOWNLOADING"], payLoad: true });
      const response =
        await revenuePayoutService.getAllRevenuePayoutsNoPagination(
          payload,
          page,
        );
      dispatch({ type: payoutType["DOWNLOADING"], payLoad: false });
      // dispatch({ type: payoutType["ALL_REFERRALS"], payLoad: response });
      return response;
    } catch (error) {
      dispatch({ type: payoutType["DOWNLOADING"], payLoad: false });
    }
  };

/**
 * Search referrals
 **/

export const searchRevenuePayout = (payload) => async (dispatch) => {
  try {
    dispatch({ type: payoutType["SEARCHING"], payLoad: true });
    const response = await revenuePayoutService.searchRevenuePayout(payload);
    dispatch({ type: payoutType["SEARCHING"], payLoad: false });
    dispatch({ type: payoutType["SEARCH_REFERRALS"], payLoad: response });
    return response;
  } catch (error) {
    dispatch({ type: payoutType["SEARCHING"], payLoad: false });
  }
};

/**
 * Filter referrals
 **/

export const filterRevenuePayouts = (payload, page) => async (dispatch) => {
  try {
    dispatch({ type: payoutType["FILTERING_REVENUE_PAYOUT"], payLoad: true });
    const response = await revenuePayoutService.filterRevenuePayouts(
      payload,
      page,
    );
    dispatch({ type: payoutType["FILTERING_REVENUE_PAYOUT"], payLoad: false });
    dispatch({ type: payoutType["FILTER_REVENUE_PAYOUT"], payLoad: response });
    return response;
  } catch (error) {
    dispatch({ type: payoutType["FILTERING_REVENUE_PAYOUT"], payLoad: false });
    errorHandler(error, true);
  }
};

/**
 * Edit revenue payout
 **/

export const editRevenuePayout = (payload, page) => async (dispatch) => {
  try {
    dispatch({ type: payoutType["LOADING_REVENUE_PAYOUT"], payLoad: true });
    const response = await revenuePayoutService.editRevenuePayout(
      payload,
      page,
    );
    dispatch({ type: payoutType["LOADING_REVENUE_PAYOUT"], payLoad: false });
    dispatch({ type: payoutType["FILTER_REFERRALS"], payLoad: response });
    return response;
  } catch (error) {
    dispatch({ type: payoutType["LOADING_REVENUE_PAYOUT"], payLoad: false });
    errorHandler(error, true);
  }
};

/**
 * store revenue payout
 **/

export const storeRevenuePayout = (payload, page) => async (dispatch) => {
  try {
    dispatch({ type: payoutType["LOADING_REVENUE_PAYOUT"], payLoad: true });
    const response = await revenuePayoutService.storeRevenuePayout(
      payload,
      page,
    );
    dispatch({ type: payoutType["LOADING_REVENUE_PAYOUT"], payLoad: false });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({ type: payoutType["LOADING_REVENUE_PAYOUT"], payLoad: false });
    errorHandler(error, true);
  }
};

/**
 * approve revenue payout
 * @param {object} payLoad {id:"", approval_reason:""}
 **/
export const approveRevenuePayout = (payLoad) => async (dispatch) => {
  try {
    dispatch({
      type: payoutType["APPROVING_REVENUE_PAYOUT"],
      payLoad: true,
    });
    const response = await revenuePayoutService.approveRevenuePayout(payLoad);
    dispatch({
      type: payoutType["APPROVING_REVENUE_PAYOUT"],
      payLoad: false,
    });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({
      type: payoutType["APPROVING_REVENUE_PAYOUT"],
      payLoad: false,
    });

    errorHandler(error, true);
  }
};

/**
 * reject revenue payout
 * @param {object} payLoad {id:"", rejection_reason:""}
 **/
export const rejectRevenuePayout = (payLoad) => async (dispatch) => {
  try {
    dispatch({
      type: payoutType["APPROVING_REVENUE_PAYOUT"],
      payLoad: true,
    });
    const response = await revenuePayoutService.rejectRevenuePayout(payLoad);
    dispatch({
      type: payoutType["APPROVING_REVENUE_PAYOUT"],
      payLoad: false,
    });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({
      type: payoutType["APPROVING_REVENUE_PAYOUT"],
      payLoad: false,
    });

    errorHandler(error, true);
  }
};


/**
 * mark an approved revenue payout as paid
 * @param {object} payLoad {id:"", provider:"", provider_reference:"", payout_reason:""}
 **/
export const markRevenuePayoutPaid = (payLoad) => async (dispatch) => {
  try {
    dispatch({
      type: payoutType["APPROVING_REVENUE_PAYOUT"],
      payLoad: true,
    });
    const response = await revenuePayoutService.markRevenuePayoutPaid(payLoad);
    dispatch({
      type: payoutType["APPROVING_REVENUE_PAYOUT"],
      payLoad: false,
    });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({
      type: payoutType["APPROVING_REVENUE_PAYOUT"],
      payLoad: false,
    });

    errorHandler(error, true);
  }
};